import React, { useEffect, useState } from 'react';

const useScrollListener = (
  targetRef: React.RefObject<HTMLDivElement>
): boolean => {
  const [isSwipingUp, setIsSwipingUp] = useState(false);

  useEffect(() => {
    let startY: number = 0;
    let startX: number = 0;
    let endY: number = 0;
    let endX: number = 0;

    const handleTouchStart = (event: TouchEvent) => {
      startY = event.touches[0].clientY;
      startX = event.touches[0].clientX;
    };

    const handleTouchEnd = (event: TouchEvent) => {
      endY = event.changedTouches[0].clientY;
      endX = event.changedTouches[0].clientX;

      const verticalSwipe = Math.abs(endY - startY);
      const horizontalSwipe = Math.abs(endX - startX);

      setIsSwipingUp(verticalSwipe > horizontalSwipe && endY < startY);
    };

    const targetElement = targetRef.current;
    targetElement?.addEventListener('touchstart', handleTouchStart);
    targetElement?.addEventListener('touchend', handleTouchEnd);

    // Clean up the event listeners when the component unmounts
    return () => {
      targetElement?.removeEventListener('touchstart', handleTouchStart);
      targetElement?.removeEventListener('touchend', handleTouchEnd);
    };
  }, [targetRef.current]);

  return isSwipingUp;
};

export default useScrollListener;